import { Sparkle } from './landing/icons'

// Figma 29.09 `banner_2` (1440 x 72) / `banner` (360 x 60), spec §2.3. Positions are frame-local,
// anchored to the page centre so the artwork stays put on screens wider than the frame.
const DARK_STAR = '#38512A'
const GREEN = '#4CBC18'

const STARS = [
  // [size desktop, left desktop, top desktop, size mobile, left mobile, top mobile, colour]
  [22, 272, 15, 9, 21, 23, GREEN],
  [10, 258, 47, 4, 16, 35, DARK_STAR],
  [22, 1197, 34, 11, 320, 29, DARK_STAR],
  [10, 1226, 16, 5, 334, 20, GREEN],
  [7, 1236, 26, 3, 339, 25, DARK_STAR],
]

const PromoBanner = () => (
  <div className="relative h-[60px] md:h-[72px] px-4 bg-brand-dark overflow-hidden">
    {/* Two small blurs instead of one wide gradient (canvas: "It should be two smaller blurs"). */}
    <span
      aria-hidden="true"
      className="absolute w-[286px] h-[286px] rounded-full bg-brand-primary opacity-[0.14] blur-[45.65px] left-[calc(50%+35px)] top-[-10px] md:left-[calc(50%-505px)] md:top-[-13px]"
    />
    <span
      aria-hidden="true"
      className="hidden md:block absolute w-[52px] h-[52px] rounded-full bg-brand-primary opacity-[0.91] blur-[45.65px] left-[calc(50%+345px)] top-[-66px]"
    />

    {STARS.map(([dSize, dLeft, dTop, mSize, mLeft, mTop, color]) => (
      <span key={`${dLeft}-${dTop}`} aria-hidden="true">
        <Sparkle
          size={mSize}
          color={color}
          className="md:hidden absolute"
          style={{ left: `calc(50% + ${mLeft - 180}px)`, top: mTop }}
        />
        <Sparkle
          size={dSize}
          color={color}
          className="hidden md:block absolute"
          style={{ left: `calc(50% + ${dLeft - 720}px)`, top: dTop }}
        />
      </span>
    ))}

    <div className="relative h-full flex flex-col items-center justify-center text-center">
      <p className="text-[16px] leading-5 md:text-[18px] md:leading-6 font-extrabold text-white">
        <span className="text-brand-primary">Founding Users</span> Save 50% for Life!
      </p>
      {/* Italic 500 as exported (the spec table's "not italic" disagrees with the export). */}
      <p className="mt-[2.5px] md:mt-[1.5px] text-[11px] leading-[14px] md:text-[13px] md:leading-4 font-medium italic text-white">
        Limited to the first 100 Pro annual subscribers.
      </p>
    </div>
  </div>
)

export default PromoBanner
